import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { Alert, AlertTitle } from '@montugroup/design-system';

export function PreOnboardingAlerts() {
  const { alert, setAlert } = usePreOnboardingContext();

  if (!alert.show) {
    return null;
  }
  return (
    <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, show: false })} sx={{ width: '100%' }}>
      {alert.title && <AlertTitle>{alert.title}</AlertTitle>}
      {alert.content}
    </Alert>
  );
}
